/**
 * [BL] Lazy video (snippets/bl-lazy-video.liquid): plays its muted, looping video only while at least a
 * quarter of it is on screen, and pauses it otherwise. The video has preload="none", so nothing
 * downloads until it first plays; a copy hidden at the current breakpoint never intersects, so it never
 * loads. With reduced motion it stays on its poster.
 */
if (!customElements.get('bl-lazy-video')) {
  const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

  customElements.define(
    'bl-lazy-video',
    class extends HTMLElement {
      connectedCallback() {
        this.video = this.querySelector('video');
        if (!this.video || reducedMotion.matches) return;
        this.observer = new IntersectionObserver(
          ([entry]) => {
            if (entry?.isIntersecting) this.video?.play().catch(() => {});
            else this.video?.pause();
          },
          { threshold: 0.25 }
        );
        this.observer.observe(this);
      }

      disconnectedCallback() {
        this.observer?.disconnect();
      }
    }
  );
}
